import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import Home from "../pages/Home";
import Registration from "./Registration";
import ScrollToTop from "../utils/ScrollToTop";
import LiveUpdate from "./LiveUpdate";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <div className="content">
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route exact path="/register">
              <Registration />
            </Route>
            <Route exact path="/finalstats">
              <LiveUpdate />
            </Route>
          </Switch>
        </div>
      </div>
      <Analytics />
    </Router>
  );
}

export default App;